export const dietsPresets = {
  WHOLE_DAY: '5',
  DAY_BASIS: '3',
  OFFICE: '2,3',
  LUNCH: '1',
};
